
import { APPSTORE_LINK } from '@/constants/links'
import Image from 'next/image'
import Link from 'next/link'
import { GA_EVENTS } from '@/utils/analytics'

const AppleButton = () => {
  const handleClick = () => {
    GA_EVENTS.DOWNLOAD_START('ios')
    GA_EVENTS.BUTTON_CLICK('apple_download')
  }

  return (
    <Link
      href={APPSTORE_LINK}
      className='border w-[153px] h-[50px] sm:w-[156px] sm:h-[56px] flex gap-2 items-center justify-center bg-pure-white rounded-5xl px-2 py-1'
      onClick={handleClick}
    >
      <Image src={'/images/Apple.svg'} alt="Apple" width={27} height={30} className='w-[23px] sm:w-[27px]' />
      <p className='text-pure-black text-md sm:text-lg'>App Store</p>
    </Link>
  )
}

export default AppleButton
